module.exports = __webpack_public_path__ + "img/Schneider Electric.cc9341ab.png";